/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        05/01/2022 07:57
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import AutoHiddingNavComponent from './components/auto-hidding-nav.component'
import BurgerMenuComponent from './components/burger-menu.component'
import LangSwitcherComponent from './components/lang-switcher.component'

document.addEventListener('DOMContentLoaded', () => {
    new AutoHiddingNavComponent()
    new BurgerMenuComponent()
    new LangSwitcherComponent()

    if ($('.header__engine-booking').length > 0) {
        setTimeout(() => {
            $('.header__engine-booking').addClass('active')
        }, 1000)
    }

    if (
        $('[data-id="social-wall"]').length > 0 &&
        !$('[data-id="social-wall"]').is(':hidden') &&
        !$('body').hasClass('eco-mode-active')
    ) {
        import('@wordpress/api-fetch' /* webpackChunkName: "scripts/wordpress_api_fetch" */).then(
            ({ default: apiFetch }) => {
                apiFetch({
                    path: Customer.irisSsoInstagramPath,
                    method: 'post',
                })
                    .then((result) => {
                        $('[data-id="social-wall"]').html(result.render)
                        import(
                            '@iris.interactive/handcook/public/scripts/components/lazyload/lazyload.component' /* webpackChunkName: "scripts/hc_lazyload" */
                        ).then(({ HcLazyload }) => {
                            HcLazyload.update()
                        })
                    })
                    .catch(() => {
                        $('[data-id="social-wall"]').html(Customer.irisSsoInstagramError)
                    })
            },
        )
    }

    $(window).on('scroll', () => {
        if ($('.sidebar').length > 0) {
            const sidebarTop = $('.sidebar').offset().top
            const sidebarHeight = $('.sidebar').height()
            const bannerHeight = $('.header__banner').height()
            const sidebarBottom = sidebarTop + sidebarHeight
            if (!$('header').hasClass('header--without-banner')) {
                if (sidebarBottom > bannerHeight) {
                    if (!$('.sidebar').hasClass('sidebar--dark')) {
                        $('.sidebar').addClass('sidebar--dark')
                    }
                } else {
                    $('.sidebar').removeClass('sidebar--dark')
                }
            }
        }
    })

    const toggleInfoLive = (mode = 'toggle') => {
        if (mode === 'show') {
            if (!$('#infos-live').hasClass('active')) {
                $('#infos-live').addClass('active')
            }
            if (!$('.infos-live__overlay').hasClass('active')) {
                $('.infos-live__overlay').addClass('active')
            }
            if (!$('body').hasClass('infos-live-is-open')) {
                $('body').addClass('infos-live-is-open')
            }
        } else if (mode === 'hide') {
            $('#infos-live').removeClass('active')
            $('.infos-live__overlay').removeClass('active')
            $('body').removeClass('infos-live-is-open')
        } else {
            $('#infos-live').toggleClass('active')
            $('.infos-live__overlay').toggleClass('active')
            $('body').toggleClass('infos-live-is-open')
        }
    }

    const toggleMessenger = (mode = 'hide') => {
        if (mode === 'show') {
            $('body').removeClass('overlay-is-open')
        } else {
            if (!$('body').hasClass('overlay-is-open')) {
                $('body').addClass('overlay-is-open')
            }
        }
    }

    const toggleHeaderSticky = (mode = 'toggle') => {
        if (mode === 'enable') {
            if (!$('.header').hasClass('is-sticky')) {
                $('.header').addClass('is-sticky')
            }
        } else if (mode === 'disable') {
            $('.header').removeClass('is-sticky')
        } else {
            $('.header').toggleClass('is-sticky')
        }
    }

    $('[data-trigger="infos-live"], [data-trigger="infos-live-close"], .infos-live__overlay').on(
        'click',
        () => {
            toggleInfoLive()
            toggleHeaderSticky()

            if ($('#infos-live').hasClass('active')) {
                toggleMessenger('hide')
            } else {
                toggleMessenger('show')
            }
        },
    )

    document.addEventListener('show.hc.modal', () => {
        toggleInfoLive('hide')
        toggleMessenger('hide')
    })

    document.addEventListener('hide.hc.modal', () => {
        toggleMessenger('show')
    })

    document.addEventListener('open.hc.menu', () => {
        toggleMessenger('hide')
        $('.bottom-bar').addClass('overlay-is-open')
    })

    document.addEventListener('close.hc.menu', () => {
        toggleMessenger('show')
        $('.bottom-bar').removeClass('overlay-is-open')
    })

    $('[data-trigger="wpet-agenda-period"]').on('click', function (e) {
        e.preventDefault()
        const val = $(this).attr('data-value')
        $('[name="wpet_search[period][list]"]').val(val)
        $(this).parents('form').submit()
    })

    $(document).on('click', '.tippy-content .glink', () => {
        import(
            '@iris.interactive/handcook/public/scripts/components/dropdown/dropdown.component' /* webpackChunkName: "scripts/hc_dropdown" */
        ).then(({ HcDropdown }) => {
            HcDropdown.hideAll()
        })
    })
})
